module.exports = __webpack_public_path__ + "img/wms-h.5acd57ce.svg";